import {HttpClient} from "@angular/common/http";
import {Injectable} from "@angular/core";
import {Observable, map} from "rxjs";
import {LoaderService} from "./loader.service";
import {PagedFilter, CompetitorFilter, FindEventsRequest, FindUsersDetailsRequest, RequestFilter} from "@model";
import { FindOrganisersRequest } from "../model/find-organisers-request";
import {EnvironmentService} from "./environment.service";

@Injectable({ providedIn:'root' })
export class ExportService {
  constructor(private http: HttpClient,private loaderService: LoaderService, private environmentService:EnvironmentService) {
  }

  downloadListOfEventsFile(type: string, filter: FindEventsRequest): Observable<Blob> {
    this.loaderService.startLoading();
    return this.http.post<any>(this.environmentService.getApiUrl() + "/api/export/event/" + type, filter, {responseType: 'blob' as 'json'}).pipe(map((value: any) => {
      if (value) {
        this.loaderService.dismissLoading();
        return value;
      } else {
        this.loaderService.dismissLoading();
        return [];
      }
    }));
  }

  downloadStartListFile(type: string, eventId: number): Observable<Blob> {
    this.loaderService.startLoading();
    return this.http.post<any>(this.environmentService.getApiUrl() + "/api/export/event/startlist/" + type, eventId, {responseType: 'blob' as 'json'}).pipe(map((value: any) => {
      if (value) {
        this.loaderService.dismissLoading();
        return value;
      } else {
        this.loaderService.dismissLoading();
        return [];
      }
    }));
  }

  downloadRacesForEventFile(type: string, eventId: number): Observable<Blob> {
    this.loaderService.startLoading();
    return this.http.post<any>(this.environmentService.getApiUrl() + "/api/export/event/racelist" + type, eventId, {responseType: 'blob' as 'json'}).pipe(map((value: any) => {
      if (value) {
        this.loaderService.dismissLoading();
        return value;
      } else {
        this.loaderService.dismissLoading();
        return [];
      }
    }));
  }



  downloadCompetitorsListForRaceFile(type: string, filter: PagedFilter<CompetitorFilter>): Observable<Blob> {
    this.loaderService.startLoading();
    return this.http.post<any>(this.environmentService.getApiUrl() + "/api/export/race/competitorlist/" + type, filter, {responseType: 'blob' as 'json'}).pipe(map((value: any) => {
      if (value) {
        this.loaderService.dismissLoading();
        return value;
      } else {
        this.loaderService.dismissLoading();
        return [];
      }
    }));

  }
  downloadResultsForRaceFile(type: string, filter: PagedFilter<CompetitorFilter> | undefined): Observable<Blob> {
    this.loaderService.startLoading();
    return this.http.post<any>(this.environmentService.getApiUrl() + "/api/export/race/results/" + type, filter, {responseType: 'blob' as 'json'}).pipe(map((value: any) => {
      if (value) {
        this.loaderService.dismissLoading();
        return value;
      } else {
        this.loaderService.dismissLoading();
        return [];
      }
    }));
  }

  downloadCompetitorsListForEventFile(type: string, filter:PagedFilter<CompetitorFilter> | undefined): Observable<Blob> {
    this.loaderService.startLoading();
    return this.http.post<any>(this.environmentService.getApiUrl() + "/api/export/event/competitorlist/" + type, filter, {responseType: 'blob' as 'json'}).pipe(map((value: any) => {
      if (value) {
        this.loaderService.dismissLoading();
        return value;
      } else {
        this.loaderService.dismissLoading();
        return [];
      }
    }));

  }

  downloadLeagues(type: string, filter: FindEventsRequest): Observable<Blob> {
    this.loaderService.startLoading();
    return this.http.post<any>(this.environmentService.getApiUrl() + "/api/export/leagues/" + type, filter, {responseType: 'blob' as 'json'}).pipe(map((value: any) => {
      if (value) {
        this.loaderService.dismissLoading();
        return value;
      } else {
        this.loaderService.dismissLoading();
        return [];
      }
    }));

  }

  downloadLeagueEvents(type: string, leagueId: number): Observable<Blob> {
    this.loaderService.startLoading();
    return this.http.post<any>(this.environmentService.getApiUrl() + "/api/export/league/events/" + type, leagueId, {responseType: 'blob' as 'json'}).pipe(map((value: any) => {
      if (value) {
        this.loaderService.dismissLoading();
        return value;
      } else {
        this.loaderService.dismissLoading();
        return [];
      }
    }));
  }

  downloadUsersByRole(type: string, filter: FindUsersDetailsRequest | undefined): Observable<Blob> {
    this.loaderService.startLoading();
    return this.http.post<any>(this.environmentService.getApiUrl() + "/api/export/users/" + type, filter, {responseType: 'blob' as 'json'}).pipe(map((value: any) => {
      if (value) {
        this.loaderService.dismissLoading();
        return value;
      } else {
        this.loaderService.dismissLoading();
        return [];
      }
    }));
  }

  downloadOrganisers(type: string, filter: FindOrganisersRequest): Observable<Blob> {
    this.loaderService.startLoading();
    return this.http.post<any>(this.environmentService.getApiUrl() + "/api/export/organisers/" + type, filter, {responseType: 'blob' as 'json'}).pipe(map((value: any) => {
      if (value) {
        this.loaderService.dismissLoading();
        return value;
      } else {
        this.loaderService.dismissLoading();
        return [];
      }
    }));
  }

  downloadRequests(type: string, filter:PagedFilter<RequestFilter> | undefined): Observable<Blob> {
    this.loaderService.startLoading();
    return this.http.post<any>(this.environmentService.getApiUrl() + "/api/export/requests/" + type, filter, {responseType: 'blob' as 'json'}).pipe(map((value: any) => {
      if (value) {
        this.loaderService.dismissLoading();
        return value;
      } else {
        this.loaderService.dismissLoading();
        return [];
      }
    }));
  }

  downloadAdmins(type: string, filter: FindOrganisersRequest): Observable<Blob> {
    this.loaderService.startLoading();
    return this.http.post<any>(this.environmentService.getApiUrl() + "/api/export/administrators/" + type, filter, {responseType: 'blob' as 'json'}).pipe(map((value: any) => {
      if (value) {
        this.loaderService.dismissLoading();
        return value;
      } else {
        this.loaderService.dismissLoading();
        return [];
      }
    }));
  }
}
